import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';

import data from './data';
import { viewport } from '../../../common/config';
import PreviewHeading from '../../../components/PreviewHeading';
import { Subtitle } from '../styled';
import useAnimation from '../History/useAnimation';

const Wrapper = styled.div`
  cursor: pointer;
  display: none;

  @media screen and (min-width: ${viewport.md}) {
    display: block;
  }
`;

const PreviewContent = ({ index, incrementIndex }: {
  index: number,
  incrementIndex: () => void
}) => {
  const question = useRef<HTMLHeadingElement>(null);

  const [localIndex, setLocalIndex] = useState(index);

  const [fadeout, fadein] = useAnimation([question]);

  useEffect(() => {
    fadeout.current?.play(0).eventCallback("onComplete", () => {
      setLocalIndex(index);
      fadein.current?.play(0);
    });
  }, [index]);

  return (
    <Wrapper onClick={incrementIndex}>
      <PreviewHeading />

      <Subtitle ref={question}>{data[localIndex].question}</Subtitle>
    </Wrapper>
  );
}

export default PreviewContent;